import { Component, computed, Input, OnDestroy, OnInit, Signal, signal } from '@angular/core';
import { Subscription } from 'rxjs';

import { TimerService } from 'src/app/services/timer.service';
import { TEST_NAVBAR_UI } from '../../constants/ui-strings';
import { TestService } from 'src/app/services/test.service';
import { ProctorSetting } from 'src/app/model/proctor-setting';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-test-navbar',
  templateUrl: './test-navbar.component.html',
  styleUrl: './test-navbar.component.scss',
})
export class TestNavbarComponent implements OnInit, OnDestroy {
  @Input() showCompleteNavbar: boolean;

  submitTestPopup = this.utilService.endTestPopup;
  instructionPopup: boolean = false;
  totalQuestions: number = 0;
  attempted: number = 0;
  skipped: number = 0;
  testNavbarUIStrings = TEST_NAVBAR_UI;
  timeRemaining: number = 0;
  proctoringSetting: ProctorSetting = this.testService.testData().proctor_settings;
  timerSubscription$: Subscription | undefined;
  testName: string;
  constructor (
    private timerService: TimerService,
    private testService: TestService,
    private utilService: UtilService
  ) {}

  ngOnInit(): void {
    this.timerService.startTimer()
    this.timerSubscription$ = this.timerService.timeRemaining$.subscribe(time => {
      this.timeRemaining = time;
    });
    this.testName = this.testService.testData()?.test_name;
  }

  formatTime(time: number): string {
    return this.timerService.formatTime(time);
  }

  ngOnDestroy() {
    if (this.timerSubscription$) {
      this.timerSubscription$?.unsubscribe();
    }
  }

  showCompleteNavbarSubscription$: Subscription;

  showInstructionPopup(): void {
    this.instructionPopup = true;
  }

  showFinalQuizPopup(): void {
    this.submitTestPopup.set(true);
  }
}
